module.exports = __webpack_public_path__ + "02_glasses_brown.627ab65e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/02_glasses_brown.png
// module id = 8m5i
// module chunks = 0